import tourHelper from '@/functions/tourHelper.js'
import Shepherd from 'shepherd.js'

export default {
  data () {
    return {
      cookie: {
        name: 'activity-tour',
        value: true
      },
      modalTourProps: {
        submitButtonText: 'Mulai Eksplor',
        closeButtonText: 'Lewati',
        modalTitle: 'Tampilan Baru Halaman Belajar',
        modalText: `
          <p class="inter-medium_small-normal text-ui-primary">
            Eksplor tampilan terbaru dari halaman belajar Karier.mu yang bisa bantu proses belajar Anda jadi lebih optimal.
          </p>
        `,
        modalImage: 'https://cdn.karier.mu/assets/kariermu/v2/halaman-belajar/tampilan-baru-halaman-belajar.webp'
      },
      tourSteps: {
        menuBelajar: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/menu-belajar.webp',
          title: 'Menu Belajar',
          description: 'Periksa setiap menu belajar supaya proses belajar Anda menjadi optimal.'
        },
        daftarAktivitas: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/daftar-aktivitas.webp',
          title: 'Daftar Aktivitas',
          description: 'Pelajari dan selesaikan setiap aktivitas yang terdapat di menu daftar aktivitas.'
        },
        menuUtama: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/menu-utama.webp',
          title: 'Menu Utama',
          description: 'Periksa menu utama lainnya untuk melihat penilaian di kelas ini.'
        },
        tutupMenuUtama: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/tutup-daftar-aktivitas.webp',
          title: 'Tutup Menu Utama',
          description: 'Tutup menu utama untuk tampilan halaman belajar yang lebih luas.'
        },
        menuLainnya: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/menu-lainnya.webp',
          title: 'Menu Lainnya',
          description: 'Anda bisa melihat menu lainnya di sini.'
        },
        eksplorasiHalamanBelajar: {
          image: 'https://cdn.karier.mu/assets/kariermu/v2/coachmark/eksplorasi-halaman-belajar.webp',
          title: 'Eksplorasi Halaman Belajar',
          description: 'Anda bisa melihat penjelasan halaman ini kembali melalui menu <strong>Eksplorasi Halaman Belajar</strong>.'
        }
      }
    }
  },
  computed: {
    isShowModalTour: {
      get () {
        return this.$store.state.activityV2.isShowModalTour
      },
      set (value) {
        this.$store.commit('activityV2/TOGGLE_MODAL_TOUR', value)
      }
    },
    isSidebarVisible () {
      return this.$store.state.activityV2.isSidebarVisible
    },
    isFullScreen () {
      return window.innerWidth >= 992
    },
    activeNav () {
      const navMobile = document.querySelector('.nav-mobile')
      if (window.getComputedStyle(navMobile).display === 'none') {
        return '.navbar-collapse'
      }
      return '.nav-mobile'
    },
    payloadDesktop () {
      return [
        {
          element: '#topic-wrapper-tour',
          ...this.tourSteps.daftarAktivitas,
          position: 'left',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          scrollTo: false
        },
        {
          element: '.activity-v2-tab-menu>ul.nav.nav-tabs',
          ...this.tourSteps.menuBelajar,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          modalOverlayOpeningPadding: -1,
          scrollTo: false
        },
        {
          element: '.sidebar-nav>.nav-tabs',
          ...this.tourSteps.menuUtama,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          scrollTo: false,
          modalOverlayOpeningPadding: -3
        },
        {
          element: '#btn-close-sidebar',
          ...this.tourSteps.tutupMenuUtama,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          scrollTo: false
        },
        {
          element: `${this.activeNav} #navbar-others-menu-v2 > button`,
          ...this.tourSteps.menuLainnya,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => { await this.setSidebar(true) },
          modalOverlayOpeningPadding: -3,
          scrollTo: false
        },
        {
          element: '#explore-halaman-belajar-dropdown-menu',
          ...this.tourSteps.eksplorasiHalamanBelajar,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => {
            const element = document.querySelector(`${this.activeNav} #navbar-others-menu-v2 > button`)
            if (element) {
              element.click()
            }
            await this.setSidebar(true)
          },
          scrollTo: false
        }
      ]
    },
    payloadMobile () {
      return [
        {
          element: '#activity-v2-banner-btn-toggle-sidebar',
          ...this.tourSteps.daftarAktivitas,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(false),
          scrollTo: false
        },
        {
          element: '.activity-v2-tab-menu>ul.nav.nav-tabs',
          ...this.tourSteps.menuBelajar,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(false),
          modalOverlayOpeningPadding: -1,
          modalOverlayOpeningRadius: 1,
          scrollTo: false
        },
        {
          element: '.sidebar-nav>.nav-tabs',
          ...this.tourSteps.menuUtama,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          modalOverlayOpeningPadding: -3,
          scrollTo: false
        },
        {
          element: '#btn-close-sidebar',
          ...this.tourSteps.tutupMenuUtama,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(true),
          scrollTo: false
        },
        {
          element: `${this.activeNav} #navbar-others-menu-v2>button`,
          ...this.tourSteps.menuLainnya,
          position: 'bottom',
          usingCustomFunction: true,
          customFunction: async () => await this.setSidebar(false),
          modalOverlayOpeningPadding: -3,
          scrollTo: false
        },
        {
          element: '#explore-halaman-belajar-bottom-sheet-menu',
          ...this.tourSteps.eksplorasiHalamanBelajar,
          position: 'top',
          usingCustomFunction: true,
          customFunction: async () => {
            await this.setSidebar(false)
            document.querySelector(`${this.activeNav} #navbar-others-menu-v2>button`).click()
            await new Promise(resolve => setTimeout(resolve, 500)) // wait till bottom sheet fully shown, approx 500ms
          },
          scrollTo: false
        }
      ]
    }
  },
  methods: {
    async setSidebar (value) {
      if (this.isSidebarVisible !== value) {
        this.$store.commit('activityV2/TOGGLE_SIDEBAR', value)
        await new Promise(resolve => setTimeout(resolve, 750)) // wait till sidebar fully shown, approx 750ms
      }
    },
    cleanUpTour () {
      this.$store.commit('activityV2/SET_TOUR', false)
      this.$store.commit('activityV2/SET_TOUR_FINISHED', false)
      document
        .querySelectorAll('[class^="shepherd"]')
        .forEach(element => {
          element.remove()
        })
    },
    initTour () {
      this.cleanUpTour()
      this.toggleModalTour(false)
      this.$store.commit('activityV2/SET_TOUR', true)
      this.$nextTick(() => {
        const tour = new Shepherd.Tour(tourHelper.option)
        const steps = tourHelper.parseTourPayload({
          tour,
          payload: this.isFullScreen ? this.payloadDesktop : this.payloadMobile
        })
        tour.addSteps(steps)
        tour.start()
        tour.on('cancel', this.handleCancelledTour)
        tour.on('complete', this.handleCompletedTour)
      })
    },
    handleCancelledTour () {
      if (!this.$cookies.get(this.cookie.name)) {
        this.$nextTick(() => {
          const tour = new Shepherd.Tour(tourHelper.option)
          const payloadItem = { ...this.isFullScreen ? this.payloadDesktop.at(-1) : this.payloadMobile.at(-1) }
          payloadItem.cancelIcon = { enabled: false }
          const steps = tourHelper.parseTourPayload({
            tour,
            payload: [payloadItem]
          })
          tour.addSteps(steps)
          tour.start()
          tour.on('complete', this.handleCompletedTour)
        })
      } else this.handleCompletedTour()
    },
    handleCompletedTour () {
      this.$cookies.set(this.cookie.name, true)
      this.$store.commit('activityV2/SET_TOUR', false)
      this.$store.commit('activityV2/SET_TOUR_FINISHED', true)
    },
    initModalTour () {
      this.isShowModalTour = !this.$cookies.get(this.cookie.name) && !this.$store.state.activityV2.isVisibleRedeemCodeModal
    },
    toggleModalTour (value) {
      this.isShowModalTour = value !== null ? value : !this.isShowModalTour
    },
    closeModalTour () {
      this.toggleModalTour(false)
      this.handleCancelledTour()
    }
  },
  beforeRouteLeave (to, from, next) {
    this.cleanUpTour()
    next()
  }
}
